<template>
	<div class="drug-management-container">
		<!-- 左侧表格区域 -->
		<div class="left-table-section" :class="{ 'collapsed': isRightVisible }">
			<!-- 顶部分类标签 -->
			<div class="category-tabs">
				<div class="lr">
					<el-radio-group v-model="activeCategory" class="category-group">
						<el-radio-button label="诊所管理">诊所管理</el-radio-button>
					</el-radio-group>
					<el-button type="warning" plain icon="el-icon-plus" style="margin-left: 12px" @click="handleAdd">
						新建诊所
					</el-button>
				</div>
			</div>

			<!-- 搜索和筛选区域 -->
			<div class="search-filter-section">
				<div class="filter-group">
					<span class="filter-label">状态</span>
					<el-select v-model="filterStatus" size="mini" placeholder="全部" style="width: 120px">
						<el-option label="全部" value=""></el-option>
						<el-option label="启用" value="1"></el-option>
						<el-option label="禁用" value="0"></el-option>
					</el-select>

					<el-input v-model="searchName" placeholder="诊所名称" size="mini" clearable
						style="width: 200px; margin-left: 12px" />

					<el-button type="primary" round size="mini" icon="el-icon-Ssearch" style="margin-left: 12px"
						@click="handleSearch">
						查询
					</el-button>


				</div>
			</div>

			<!-- 本地目录表格 -->
			<div class="table-section">
				<div class="table-header">
					<span class="table-title">诊所管理列表</span>
				</div>

				<el-table :data="leftTableData" v-loading="loading" border size="mini" style="width: 100%"
					class="drug-table" height="calc(88vh - 228px)" @row-click="handleRowClick">
					<el-table-column type="selection" width="40" align="center">
						<template slot-scope="scope">
							<el-radio v-model="selectedRowId" :label="scope.row.id"
								@click.native.stop="handleRadioClick(scope.row)"
								class="radio-selection">&nbsp;</el-radio>
						</template>
					</el-table-column>

					<el-table-column type="index" label="序号" width="60" align="center" />
					<el-table-column prop="status" label="状态" width="100" align="center">
						<template slot-scope="scope">
							<el-tag :type="scope.row.status === '1' ? 'success' : 'danger'" size="mini">
								{{ scope.row.status === '1' ? '启用' : '禁用' }}
							</el-tag>
						</template>
					</el-table-column>
					<el-table-column prop="name" label="名称" min-width="180" align="center" show-overflow-tooltip />
					<el-table-column prop="code" label="编码" min-width="150" align="center" show-overflow-tooltip />
					<el-table-column prop="pinyin" label="拼音简码" width="120" align="center" />
					<el-table-column prop="logoPath" label="Logo地址" width="150" align="center" />
					<el-table-column prop="advertisImage" label="广告宣传图片" width="150" align="center" />
					<el-table-column label="操作" width="180" align="center" fixed="right" class-name="operation-column">
						<template slot-scope="scope">
							<div class="operation-buttons"
								style="display: flex; justify-content: center; align-items: center; height: 100%;">
								<el-button type="primary" size="mini" @click="showDetail(scope.row)"
									style="margin: 0 4px;">
									详情
								</el-button>
								<!--
                          <el-button
                            type="danger"
                            size="mini"
                            @click="handleDelete(scope.row.id)"
                            style="margin: 0 4px;"
                          >
                            删除
                          </el-button>
                          -->
							</div>
						</template>
					</el-table-column>
				</el-table>

				<!-- 分页组件 -->
				<div class="pagination-container">
					<el-pagination @size-change="handleLeftSizeChange" @current-change="handleLeftCurrentChange"
						:current-page="leftPagination.currentPage" :page-sizes="[10, 20, 50, 100]"
						:page-size="leftPagination.pageSize" layout="total, sizes, prev, pager, next, jumper"
						:total="leftPagination.total" size="mini" class="pagination" />
				</div>
			</div>
		</div>

		<!-- 右侧详情表格区域 -->
		<div class="right-table-section" :class="{ 'visible': isRightVisible }">
			<div class="right-header">
				<div class="right-title">{{ currentDetail ? currentDetail.name : '诊所详情' }}</div>
				<div class="right-operations">
					<el-button type="primary" size="mini" icon="el-icon-edit" @click="handleEdit(currentDetail)"
						v-if="currentDetail">
						修改
					</el-button>
					<el-button size="mini" icon="el-icon-close" @click="hideDetail">关闭</el-button>
				</div>
			</div>

			<!-- 右侧详情内容 -->
			<div class="right-detail-content" v-if="currentDetail">
				<!-- 图片展示区域 -->
				<div class="image-gallery" v-if="hasImages">
					<div class="gallery-item" v-if="currentDetail.logoPath">
						<div class="image-title">诊所Logo</div>
						<el-image :src="currentDetail.logoPath" fit="cover" class="clinic-image"
							:preview-src-list="[currentDetail.logoPath]">
							<div slot="error" class="image-error">
								<i class="el-icon-picture-outline"></i>
								<span>图片加载失败</span>
							</div>
						</el-image>
					</div>

					<div class="gallery-item" v-if="currentDetail.advertisImage">
						<div class="image-title">广告宣传图片</div>
						<el-image :src="currentDetail.advertisImage" fit="cover" class="clinic-image"
							:preview-src-list="[currentDetail.advertisImage]">
							<div slot="error" class="image-error">
								<i class="el-icon-picture-outline"></i>
								<span>图片加载失败</span>
							</div>
						</el-image>
					</div>
				</div>

				<!-- 详细信息区域 -->
				<div class="detail-info">
					<el-descriptions :column="1" border size="mini" class="clinic-descriptions">
						<el-descriptions-item label="诊所名称">{{ currentDetail.name }}</el-descriptions-item>
						<el-descriptions-item label="编码">{{ currentDetail.code }}</el-descriptions-item>
						<el-descriptions-item label="拼音简码">{{ currentDetail.pinyin }}</el-descriptions-item>
						<el-descriptions-item label="诊所地址">{{ currentDetail.address }}</el-descriptions-item>
						<el-descriptions-item label="状态">
							<el-tag :type="currentDetail.status === '1' ? 'success' : 'danger'" size="mini">
								{{ currentDetail.status === '1' ? '启用' : '禁用' }}
							</el-tag>
						</el-descriptions-item>
						<el-descriptions-item label="是否医保">
							{{ currentDetail.isInsurance === '1' ? '是' : '否' }}
						</el-descriptions-item>
						<el-descriptions-item label="就医地医保区划" v-if="currentDetail.isInsurance === '1'">
							{{ currentDetail.mdtrtareaAdmvs }}
						</el-descriptions-item>
						<el-descriptions-item label="创建时间">{{ currentDetail.createTime }}</el-descriptions-item>
						<el-descriptions-item label="更新时间">{{ currentDetail.updateTime }}</el-descriptions-item>
					</el-descriptions>
				</div>
			</div>
		</div>


		<!-- 新增/编辑诊所模态框 -->
		<el-dialog :title="dialogTitle" :visible.sync="addMenuDialog" width="50%" :before-close="handleClose"
			class="clinic-dialog" top="48px">
			<div class="dialog-header">
				<span class="dialog-title">{{ dialogTitle }}</span>
				<el-button size="mini" icon="el-icon-close" @click="addMenuDialog = false"
					class="close-btn">关闭</el-button>
			</div>

			<div class="dialog-content">
				<!-- 诊所基本信息 -->
				<div class="form-section">
					<div class="section-title">诊所基本信息</div>
					<el-form ref="addForm" :model="addForm" :rules="addFormRules" label-width="120px" size="mini"
						class="clinic-form">
						<el-row :gutter="20">
							<el-col :span="12">
								<el-form-item label="诊所名称" prop="name">
									<el-input v-model="addForm.name" placeholder="请输入诊所名称" @blur="generatePinyin"
										@input="clearPinyinIfNameChanged" />
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="拼音简码">
									<el-input v-model="addForm.pinyin" placeholder="自动生成" readonly />
								</el-form-item>
							</el-col>

							<el-col :span="12">
								<el-form-item label="电话" prop="tel">
									<el-input v-model="addForm.tel" placeholder="请输入诊所电话" />
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="状态" prop="status">
									<el-select v-model="addForm.status" placeholder="请选择状态" style="width: 100%">
										<el-option label="启用" value="1" />
										<el-option label="禁用" value="0" />
									</el-select>
								</el-form-item>
							</el-col>

							<el-col :span="12">
								<el-form-item label="诊所地址" prop="address">
									<el-input v-model="addForm.address" placeholder="请输入诊所地址" />
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="过期日期" prop="expireDate">
									<el-date-picker v-model="addForm.expireDate" type="date" placeholder="选择日期"
										style="width: 100%" :picker-options="pickerOptions" value-format="yyyy-MM-dd"
										format="yyyy-MM-dd" />
								</el-form-item>
							</el-col>

							<el-col :span="12">
								<el-form-item label="营业证件地址" prop="businessLicense">
									<el-cascader v-model="addForm.businessLicense" :options="regionOptions"
										:props="cascaderProps" placeholder="请选择地区" style="width: 100%"
										@change="handleBusinessLicenseChange" />
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="职业许可证地址" prop="practicLicense">
									<el-cascader v-model="addForm.practicLicense" :options="regionOptions"
										:props="cascaderProps" placeholder="请选择地区" style="width: 100%"
										@change="handlePracticLicenseChange" />
								</el-form-item>
							</el-col>

							<el-col :span="24">
								<el-form-item label="备注" prop="remarks">
									<el-input v-model="addForm.remarks" type="textarea" :rows="2" placeholder="请输入备注信息"
										maxlength="200" show-word-limit />
								</el-form-item>
							</el-col>

							<el-col :span="24">
								<el-form-item label="单位简介" prop="companyProfile">
									<el-input v-model="addForm.companyProfile" type="textarea" :rows="3"
										placeholder="请输入单位简介" maxlength="500" show-word-limit />
								</el-form-item>
							</el-col>
						</el-row>
					</el-form>
				</div>

				<!-- 医保信息 -->
				<div class="form-section">
					<div class="section-title">医保信息</div>
					<el-form ref="insuranceForm" :model="addForm" :rules="insuranceRules" label-width="120px"
						size="mini" class="insurance-form">
						<el-row :gutter="20">
							<el-col :span="24">
								<el-form-item label="是否医保" prop="isInsurance">
									<el-radio-group v-model="addForm.isInsurance" @change="handleInsuranceChange">
										<el-radio :label="1">是</el-radio>
										<el-radio :label="0">否</el-radio>
									</el-radio-group>
								</el-form-item>
							</el-col>
						</el-row>

						<!-- 医保信息字段 -->
						<el-row :gutter="20" v-if="addForm.isInsurance == 1">
							<el-col :span="12">
								<el-form-item label="医疗机构编码" prop="code">
									<el-input v-model="addForm.code" placeholder="请输入医疗机构编码" />
								</el-form-item>
							</el-col>

							<el-col :span="12">
								<el-form-item label="就医地医保区划" prop="mdtrtareaAdmvs">
									<el-input v-model="addForm.mdtrtareaAdmvs" placeholder="请输入就医地医保区划" />
								</el-form-item>
							</el-col>
						</el-row>
					</el-form>
				</div>

				<!-- 文件上传 -->
				<div class="form-section">
					<div class="section-title">文件上传</div>
					<el-row :gutter="20" class="file-upload-section">
						<el-col :span="12">
							<div class="upload-item">
								<div class="upload-label">Logo地址</div>
								<el-upload action="#" :auto-upload="false" :on-change="handleLogoChange"
									:file-list="logoList" list-type="picture-card" :limit="1" :show-file-list="false"
									:before-upload="beforeLogoUpload" :on-remove="handleLogoRemove"
									:on-exceed="handleLogoExceed">
									<i class="el-icon-plus" v-if="!addForm.logoPath"></i>
									<div v-else class="upload-preview">
										<el-image :src="addForm.logoPath" fit="cover" class="upload-preview-image">
											<div slot="error" class="upload-error">
												<i class="el-icon-picture-outline"></i>
											</div>
										</el-image>
									</div>
								</el-upload>
								<div class="upload-tip" v-if="!addForm.logoPath">点击上传Logo</div>
								<div class="uploading-tip" v-if="logoUploading">上传中...</div>
								<el-button v-if="addForm.logoPath" type="text" size="mini" @click="handleLogoRemove"
									class="upload-remove-btn">
									移除
								</el-button>
							</div>
						</el-col>

						<el-col :span="12">
							<div class="upload-item">
								<div class="upload-label">广告宣传图片</div>
								<el-upload action="#" :auto-upload="false" :on-change="handleAdImageChange"
									:file-list="adImageList" list-type="picture-card" :limit="1" :show-file-list="false"
									:before-upload="beforeAdImageUpload" :on-remove="handleAdImageRemove"
									:on-exceed="handleAdImageExceed">
									<i class="el-icon-plus" v-if="!addForm.advertisImage"></i>
									<div v-else class="upload-preview">
										<el-image :src="addForm.advertisImage" fit="cover" class="upload-preview-image">
											<div slot="error" class="upload-error">
												<i class="el-icon-picture-outline"></i>
											</div>
										</el-image>
									</div>
								</el-upload>
								<div class="upload-tip" v-if="!addForm.advertisImage">点击上传广告图片</div>
								<div class="uploading-tip" v-if="adImageUploading">上传中...</div>
								<el-button v-if="addForm.advertisImage" type="text" size="mini"
									@click="handleAdImageRemove" class="upload-remove-btn">
									移除
								</el-button>
							</div>
						</el-col>
					</el-row>
				</div>
			</div>

			<div class="dialog-footer">
				<el-button type="primary" @click="submit" size="mini" :loading="loading">
					{{ editMode ? '保存修改' : '确 定' }}
				</el-button>
				<el-button @click="addMenuDialog = false" size="mini">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	import {
		pinyin
	} from 'pinyin-pro';
	import {
		adddocclinic,
		editdocclinic,
		docclinicPage,
		deleteDocclinic,
		getClinicDetail
	} from "@/api/cinic/cinic.js";

	// 导入地区相关的API方法
	import {
		getArea,
		getArea2,
		getArea3,
		uploadFile
	} from "@/api/user.js";

	export default {
		name: 'DrugManagement',
		computed: {
			// 检查是否有图片可显示
			hasImages() {
				return this.currentDetail && (this.currentDetail.logoPath || this.currentDetail.advertisImage);
			}
		},
		data() {
			return {
				// 左侧表格数据
				activeCategory: '诊所管理',
				filterStatus: '',
				searchName: '',
				isRightVisible: false,
				loading: false,
				selectedRowId: null,
				currentDetail: null,
				// 新增：保存原始的医保信息
				originalInsuranceData: {
					code: "",
					mdtrtareaAdmvs: ""
				},
				adImageUploading: false,
				// 模态框相关
				addMenuDialog: false,
				dialogTitle: '新增诊所',
				editMode: false,
				currentEditId: null,

				// 左侧表格数据
				leftTableData: [],
				leftPagination: {
					currentPage: 1,
					pageSize: 20,
					total: 0
				},

				// 文件上传列表
				adImageList: [],
				licenseList: [],
				practiceList: [],
				logoList: [],

				// 地区选择选项 - 初始化为空数组
				regionOptions: [],

				// 级联选择器配置
				cascaderProps: {
					lazy: true,
					lazyLoad: this.loadAreaData
				},
				// Logo上传状态
				logoUploading: false,

				// 日期选择器选项
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() < Date.now() - 8.64e7;
					}
				},

				// 表单数据
				addForm: {
					address: "",
					advertisImage: "",

					code: "",
					companyProfile: "",
					expireDate: "",
					isInsurance: 0, // 使用数字类型而不是字符串
					logoPath: "",
					mdtrtareaAdmvs: "",
					name: "",
					pinyin: "",

					remarks: "",
					status: "1",
					tel: "",
					businessLicense: [],
					practicLicense: [],
					// 添加字段存储完整的地址信息
					// businessLicenseFull: "",
					// practicLicenseFull: ""
				},

				// 表单验证规则
				addFormRules: {
					name: [{
						required: true,
						message: '请输入诊所名称',
						trigger: 'blur'
					}],
					tel: [{
							required: true,
							message: '请输入诊所电话',
							trigger: 'blur'
						},
						{
							pattern: /^1[3-9]\d{9}$|^0\d{2,3}-?\d{7,8}$/,
							message: '请输入正确的电话号码',
							trigger: 'blur'
						}
					],
					address: [{
						required: true,
						message: '请选择诊所地址',
						trigger: 'blur'
					}],
					status: [{
						required: true,
						message: '请选择状态',
						trigger: 'change'
					}],

					expireDate: [{
						required: true,
						message: '请选择过期日期',
						trigger: 'change'
					}]
				},

				// 表单验证规则
				insuranceRules: {
					code: [{
						required: true,
						message: '请输入医疗机构编码',
						trigger: 'blur',
						validator: (rule, value, callback) => {
							// 修复：使用数字类型比较
							if (this.addForm.isInsurance === 1 && !value) {
								callback(new Error('医疗机构编码为必填项'));
							} else {
								callback();
							}
						}
					}],
					mdtrtareaAdmvs: [{
						required: true,
						message: '请输入就医地医保区划',
						trigger: 'blur',
						validator: (rule, value, callback) => {
							// 修复：使用数字类型比较
							if (this.addForm.isInsurance === 1 && !value) {
								callback(new Error('就医地医保区划为必填项'));
							} else {
								callback();
							}
						}
					}]
				}
			}
		},
		watch: {
			// 修复：监听数字类型
			'addForm.isInsurance'(newVal) {
				if (newVal === 0) {
					this.addForm.code = '';
					this.addForm.mdtrtareaAdmvs = '';
				}

				this.$nextTick(() => {
					if (this.$refs.insuranceForm) {
						this.$refs.insuranceForm.clearValidate();
					}
				});
			}
		},
		mounted() {
			this.loadData();
			// 初始化时加载省级数据
			this.loadAreaProvince();
		},
		methods: {
			// 加载数据
			async loadData() {
				this.loading = true;
				try {
					let res = await docclinicPage({
						name: this.searchName,
						status: this.filterStatus,
						pageNum: this.leftPagination.currentPage,
						pageSize: this.leftPagination.pageSize,
					});

					if (res.code === 200) {
						this.leftPagination.total = res.data.totalSize;
						this.leftTableData = res.data.content;
					} else {
						this.$message.error(res.message || '获取数据失败');
					}
				} catch (error) {
					console.error(error);
					this.$message.error('请求失败');
				} finally {
					this.loading = false;
				}
			},

			// 获取完整图片URL
			getFullImageUrl(path) {
				if (!path) return '';

				// 如果已经是完整URL，直接返回
				if (path.startsWith('http')) {
					return path;
				}

				// 拼接基础URL和路径
				return `${this.imageBaseUrl}${path}`;
			},

			// 显示详情
			async showDetail(row) {
				this.loading = true;
				try {
					const res = await getClinicDetail(row.id);
					if (res.code === 200) {
						this.currentDetail = res.data;
						this.isRightVisible = true;
					} else {
						this.$message.error(res.message || '获取详情失败');
					}
				} catch (error) {
					console.error(error);
					this.$message.error('请求失败');
				} finally {
					this.loading = false;
				}
			},

			// 编辑诊所 - 修复：正确回显医保信息
			// 编辑诊所 - 修复：正确回显医保信息
			async handleEdit(row) {
				this.editMode = true;
				this.dialogTitle = `修改 - ${row.name}`;
				this.currentEditId = row.id;
				this.addMenuDialog = true;

				try {
					this.loading = true;
					const res = await getClinicDetail(row.id);
					if (res.code === 200) {
						const detailData = res.data;

						// 填充表单数据
						this.addForm = {
							...this.addForm,
							address: detailData.address || "",
							advertisImage: detailData.advertisImage || "",
							code: detailData.code || "",
							companyProfile: detailData.companyProfile || "",
							expireDate: detailData.expireDate || "",
							// 修复：确保isInsurance是数字类型
							isInsurance: parseInt(detailData.isInsurance) || 0,
							logoPath: detailData.logoPath || "",
							mdtrtareaAdmvs: detailData.mdtrtareaAdmvs || "",
							name: detailData.name || "",
							pinyin: detailData.pinyin || "",
							remarks: detailData.remarks || "",
							status: detailData.status?.toString() || "1",
							tel: detailData.tel || "",
							businessLicense: [],
							practicLicense: [],
						};

						// 保存原始的医保信息
						this.originalInsuranceData = {
							code: detailData.code || "",
							mdtrtareaAdmvs: detailData.mdtrtareaAdmvs || ""
						};

						// 处理其他字段...

						this.$message.success('诊所信息已加载');
					} else {
						this.$message.error(res.message || '获取详情失败');
					}
				} catch (error) {
					console.error(error);
					this.$message.error('请求失败');
				} finally {
					this.loading = false;
				}
			},

			// 处理医保状态变化
			handleInsuranceChange(value) {
				if (value === 0) {
					// 切换到"否"时，清空医保信息
					this.addForm.code = '';
					this.addForm.mdtrtareaAdmvs = '';
				} else if (value === 1) {
					// 切换到"是"时，恢复原始的医保信息
					// 只有当当前没有填写医保信息时才恢复原始数据
					if (!this.addForm.code && !this.addForm.mdtrtareaAdmvs) {
						this.addForm.code = this.originalInsuranceData.code;
						this.addForm.mdtrtareaAdmvs = this.originalInsuranceData.mdtrtareaAdmvs;
					}
				}

				this.$nextTick(() => {
					if (this.$refs.insuranceForm) {
						this.$refs.insuranceForm.clearValidate();
					}
				});
			},

			// 加载省级数据
			async loadAreaProvince() {
				try {
					const res = await getArea();
					if (res.code === 200) {
						this.regionOptions = res.data.map(item => ({
							value: item.areaName,
							label: item.areaName,
							leaf: false
						}));
					}
				} catch (error) {
					console.error('获取省份数据失败:', error);
					this.$message.error('获取地区数据失败');
				}
			},

			// 级联选择懒加载方法
			async loadAreaData(node, resolve) {
				try {
					const {
						level
					} = node;
					let data = [];

					if (level === 0) {
						// 已加载过省级数据，直接返回
						resolve(this.regionOptions);
						return;
					}

					if (level === 1) {
						// 加载市级数据
						const res = await getArea2({
							areaLevel: 2,
							areaPName: node.value
						});
						if (res.code === 200) {
							data = res.data.map(item => ({
								value: item.areaName,
								label: item.areaName,
								leaf: level >= 2
							}));
						}
					} else if (level === 2) {
						// 加载区级数据
						const parent = node.parent;
						const res = await getArea3({
							areaLevel: 3,
							areaPName: parent.value,
							areaCName: node.value
						});
						if (res.code === 200) {
							data = res.data.map(item => ({
								value: item.areaName,
								label: item.areaName,
								leaf: true
							}));
						}
					}

					resolve(data);
				} catch (error) {
					console.error('加载地区数据失败:', error);
					resolve([]);
				}
			},

			// 营业证件地址选择变化处理
			handleBusinessLicenseChange(value) {
				console.log('选择的营业证件地址:', value);
				// 将选择的地址数组转换为完整的地址字符串
				// this.addForm.businessLicenseFull = value.join('/');
			},

			// 执业许可证地址选择变化处理
			handlePracticLicenseChange(value) {
				console.log('选择的执业许可证地址:', value);
				// 将选择的地址数组转换为完整的地址字符串
				// this.addForm.practicLicenseFull = value.join('/');
			},

			// Logo文件变化处理
			async handleLogoChange(file, fileList) {
				if (fileList.length > 0) {
					this.logoList = [fileList[fileList.length - 1]];

					try {
						this.logoUploading = true;

						// 创建FormData对象
						const formData = new FormData();
						formData.append('file', file.raw);

						// 调用上传接口
						const res = await uploadFile(formData);

						if (res.code === 200) {
							this.$message.success('Logo上传成功');
							// 直接拼接host和path为完整地址
							this.addForm.logoPath = `${res.data.host}${res.data.path}`;
						} else {
							this.$message.error(res.message || 'Logo上传失败');
							this.logoList = [];
						}
					} catch (error) {
						console.error('Logo上传失败:', error);
						this.$message.error('Logo上传失败');
						this.logoList = [];
					} finally {
						this.logoUploading = false;
					}
				}
			},

			// Logo文件移除处理
			handleLogoRemove() {
				this.logoList = [];
				this.addForm.logoPath = "";
				this.$message.info('Logo已移除');
			},

			// Logo文件超出限制处理
			handleLogoExceed(files, fileList) {
				this.$message.warning('只能上传一张Logo图片');
			},

			// Logo上传前检查
			beforeLogoUpload(file) {
				const isImage = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif';
				const isLt5M = file.size / 1024 / 1024 < 5;

				if (!isImage) {
					this.$message.error('只能上传图片格式文件!');
					return false;
				}
				if (!isLt5M) {
					this.$message.error('图片大小不能超过5MB!');
					return false;
				}

				if (this.logoUploading) {
					this.$message.warning('已有文件正在上传，请等待完成');
					return false;
				}

				return true;
			},

			// 广告图片上传处理
			async handleAdImageChange(file, fileList) {
				if (fileList.length > 0) {
					this.adImageList = [fileList[fileList.length - 1]];

					try {
						this.adImageUploading = true;

						// 创建FormData对象
						const formData = new FormData();
						formData.append('file', file.raw);

						// 调用上传接口
						const res = await uploadFile(formData);

						if (res.code === 200) {
							this.$message.success('广告图片上传成功');
							// 直接拼接host和path为完整地址
							this.addForm.advertisImage = `${res.data.host}${res.data.path}`;
						} else {
							this.$message.error(res.message || '广告图片上传失败');
							this.adImageList = [];
						}
					} catch (error) {
						console.error('广告图片上传失败:', error);
						this.$message.error('广告图片上传失败');
						this.adImageList = [];
					} finally {
						this.adImageUploading = false;
					}
				}
			},

			// 广告图片移除处理
			handleAdImageRemove() {
				this.adImageList = [];
				this.addForm.advertisImage = "";
				this.$message.info('广告图片已移除');
			},

			// 广告图片超出限制处理
			handleAdImageExceed(files, fileList) {
				this.$message.warning('只能上传一张广告图片');
			},

			// 广告图片上传前检查
			beforeAdImageUpload(file) {
				const isImage = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif';
				const isLt5M = file.size / 1024 / 1024 < 5;

				if (!isImage) {
					this.$message.error('只能上传图片格式文件!');
					return false;
				}
				if (!isLt5M) {
					this.$message.error('图片大小不能超过5MB!');
					return false;
				}

				if (this.adImageUploading) {
					this.$message.warning('已有文件正在上传，请等待完成');
					return false;
				}

				return true;
			},

			// 搜索处理
			handleSearch() {
				this.leftPagination.currentPage = 1;
				this.loadData();
			},

			// 隐藏详情
			hideDetail() {
				this.isRightVisible = false;
				this.currentDetail = null;
			},

			// 处理行点击
			handleRowClick(row) {
				this.selectedRowId = row.id;
			},

			// 处理单选按钮点击
			handleRadioClick(row) {
				this.selectedRowId = row.id;
			},

			// 新增诊所
			handleAdd() {
				this.resetAddForm();
				this.dialogTitle = '新增诊所';
				this.editMode = false;
				this.addMenuDialog = true;
			},

			// 删除诊所
			handleDelete(id) {
				this.$confirm("此操作将永久删除该诊所, 是否继续?", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}).then(async () => {
					try {
						const res = await deleteDocclinic({
							ids: id
						});
						if (res.code === 200) {
							this.$message.success('删除成功');
							this.loadData();
						} else {
							this.$message.error(res.message || '删除失败');
						}
					} catch (error) {
						console.error(error);
						this.$message.error('请求失败');
					}
				}).catch(() => {
					this.$message.info('已取消删除');
				});
			},



			handleLicenseChange(file, fileList) {
				this.licenseList = fileList.slice(-1);
			},

			handlePracticeChange(file, fileList) {
				this.practiceList = fileList.slice(-1);
			},


			// 生成拼音简码
			generatePinyin() {
				if (this.addForm.name) {
					this.addForm.pinyin = this.makePy(this.addForm.name);
				}
			},

			// 当名称变化时清除拼音简码
			clearPinyinIfNameChanged() {
				this.addForm.pinyin = '';
			},

			// 拼音转换方法
			makePy(str) {
				if (!str) return '';
				try {
					const result = pinyin(str, {
						pattern: 'first',
						toneType: 'none',
						type: 'array'
					});

					return result.join('')
						.substring(0, 6)
						.toUpperCase();
				} catch (error) {
					console.error('生成拼音出错:', error);
					return '';
				}
			},

			// 重置表单
			resetAddForm() {
				this.addForm = {
					address: "",
					advertisImage: "",
					code: "",
					companyProfile: "",
					expireDate: "",
					// 修复：使用数字类型
					isInsurance: 0,
					logoPath: "",
					mdtrtareaAdmvs: "",
					name: "",
					pinyin: "",
					remarks: "",
					status: "1",
					tel: "",
					businessLicense: [],
					practicLicense: [],
				};

				this.adImageList = [];
				this.licenseList = [];
				this.practiceList = [];
				this.logoList = [];

				if (this.$refs.addForm) {
					this.$refs.addForm.clearValidate();
				}
				if (this.$refs.insuranceForm) {
					this.$refs.insuranceForm.clearValidate();
				}
			},

			// 关闭对话框
			handleClose(done) {
				this.$confirm('确认关闭？未保存的数据将会丢失。', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					done();
				}).catch(() => {});
			},

			// 提交表单时处理地址数据
			async submit() {
				// 确保日期格式正确
				if (this.addForm.expireDate && typeof this.addForm.expireDate === 'object') {
					// 如果是日期对象，转换为yyyy-MM-dd格式
					const date = new Date(this.addForm.expireDate);
					this.addForm.expireDate =
						`${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
				}
				this.$refs.addForm.validate((valid) => {
					if (valid) {
						this.$refs.insuranceForm.validate(async (insuranceValid) => {
							if (insuranceValid) {
								try {
									this.loading = true;

									// 准备提交数据
									const submitData = {
										...this.addForm,
										expireDate: this.addForm.expireDate || '',
										// 处理地址字段
										businessLicense: Array.isArray(this.addForm
												.businessLicense) ?
											this.addForm.businessLicense.join('/') : this
											.addForm.businessLicense,
										practicLicense: Array.isArray(this.addForm
												.practicLicense) ?
											this.addForm.practicLicense.join('/') : this
											.addForm.practicLicense
									};

									let res;
									if (this.editMode) {
										// 修改模式
										res = await editdocclinic({
											id: this.currentEditId,
											...submitData
										});
									} else {
										// 新增模式
										res = await adddocclinic(submitData);
									}

									if (res.code === 200) {
										this.$message.success(this.editMode ? '修改成功' : '新增成功');
										this.addMenuDialog = false;
										this.loadData();
									} else {
										this.$message.error(res.message || '操作失败');
									}
								} catch (error) {
									console.error(error);
									this.$message.error('请求失败');
								} finally {
									this.loading = false;
								}
							} else {
								this.$message.warning('请检查医保信息是否正确填写');
							}
						});
					} else {
						this.$message.warning('请检查诊所基本信息是否正确填写');
					}
				});
			},

			// 左侧分页
			handleLeftSizeChange(size) {
				this.leftPagination.pageSize = size;
				this.leftPagination.currentPage = 1;
				this.loadData();
			},

			handleLeftCurrentChange(page) {
				this.leftPagination.currentPage = page;
				this.loadData();
			}
		}
	}
</script>

<style lang="less" scoped>
	::v-deep .el-dialog__header {
		display: flex;
		background: linear-gradient(135deg, #1a6be0 0%, #409EFF 100%);
	}

	::v-deep .el-dialog__body {
		padding: 0;
	}

	::v-deep .el-dialog__title {
		color: #fff;
	}

	.drug-info-container {
		font-family: "Microsoft YaHei", sans-serif;
		padding: 20px;
	}

	::v-deep .el-dialog__headerbtn .el-dialog__close {
		color: #fff;
	}

	::v-deep .el-dialog__headerbtn .el-dialog__close:hover {
		color: brown;
	}

	// 操作列样式修复 - 确保垂直水平居中
	.operation-column {
		/deep/ .cell {
			display: flex;
			justify-content: center;
			align-items: center;
			height: 100%;
			padding: 0 !important;
		}
	}

	.operation-buttons {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100%;
		width: 100%;

		.el-button {
			margin: 0 4px;
			flex-shrink: 0;
		}
	}

	// 表格行高调整
	.drug-table {
		/deep/ .el-table__body {
			tr {
				height: 48px;

				td {
					padding: 8px 0;
					vertical-align: middle;

					.cell {
						line-height: 1.4;
						display: flex;
						align-items: center;
						justify-content: center;
						min-height: 32px;
					}
				}
			}
		}
	}

	.drug-management-container {
		display: flex;
		min-height: calc(88vh - 40px);
		background: #f5f5f5;
		position: relative;
		overflow: hidden;

		// 左侧表格区域
		.left-table-section {
			width: 100%;
			transition: all 0.3s ease;
			background: white;
			padding: 16px;
			box-sizing: border-box;

			&.collapsed {
				width: 50%;
			}

			.category-tabs {
				margin-bottom: 16px;

				.category-group {
					// width: 100%;

					/deep/ .el-radio-button {
						flex: 1;

						.el-radio-button__inner {
							width: 100%;
							text-align: center;
						}
					}
				}
			}

			.search-filter-section {
				margin-bottom: 16px;

				.filter-group {
					display: flex;
					align-items: center;

					.filter-label {
						font-size: 12px;
						color: #606266;
						margin-right: 8px;
						white-space: nowrap;
					}
				}
			}

			.table-section {
				.table-header {
					margin-bottom: 12px;

					.table-title {
						font-size: 14px;
						font-weight: 600;
						color: #303133;
					}
				}

				.drug-table {
					/deep/ .el-table__header-wrapper {
						th {
							background-color: #f5f7fa;
							color: #606266;
							font-weight: 600;
							padding: 8px 0;

							.cell {
								font-size: 12px;
								font-weight: 600;
							}
						}
					}

					/deep/ .el-table__body-wrapper {
						td {
							padding: 6px 0;

							.cell {
								font-size: 12px;
								line-height: 1.4;
							}
						}
					}

					.radio-selection {
						/deep/ .el-radio__inner {
							width: 16px;
							height: 16px;
						}
					}
				}
			}

			.pagination-container {
				margin-top: 16px;
				display: flex;
				justify-content: flex-end;
			}
		}

		// 右侧详情表格区域
		.right-table-section {
			width: 0;
			background: white;
			transition: all 0.3s ease;
			overflow: hidden;
			border-left: 1px solid #ebeef5;
			display: flex;
			flex-direction: column;

			&.visible {
				width: 50%;
			}

			.right-header {
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 16px 16px 0;
				margin-bottom: 16px;

				.right-title {
					font-size: 16px;
					font-weight: 600;
					color: #303133;
				}

				.right-operations {
					.el-button {
						margin-left: 8px;
					}
				}
			}

			.right-detail-content {
				padding: 0 16px;
				flex: 1;
				overflow-y: auto;

				/deep/ .el-descriptions {
					.el-descriptions-item__label {
						font-weight: 600;
						background-color: #f5f7fa;
					}
				}
			}
		}
	}

	// 模态框样式
	.clinic-dialog {
		::v-deep .el-dialog {
			border-radius: 6px;
			overflow: hidden;
			box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
		}

		::v-deep .el-dialog__header {
			display: none;
		}

		::v-deep .el-form-item__label {
			font-size: 12px;
		}

		.dialog-header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			background: linear-gradient(135deg, #1a6be0 0%, #409EFF 100%);
			padding: 12px 20px;
			color: white;

			.dialog-title {
				font-size: 16px;
				font-weight: 600;
			}

			.close-btn {
				background: transparent;
				border: 1px solid rgba(255, 255, 255, 0.5);
				color: white;

				&:hover {
					background: rgba(255, 255, 255, 0.1);
				}
			}
		}

		.dialog-content {
			padding: 20px;
			max-height: 60vh;
			overflow-y: auto;

			.form-section {
				margin-bottom: 20px;
				border: 1px solid #e4e7ed;
				border-radius: 4px;

				.section-title {
					background: #f5f7fa;
					padding: 10px 16px;
					font-size: 14px;
					font-weight: 600;
					color: #303133;
					border-bottom: 1px solid #e4e7ed;
				}

				.clinic-form,
				.insurance-form {
					padding: 16px;
				}

				.file-upload-section {
					padding: 16px;

					.upload-item {
						margin-bottom: 16px;

						.upload-label {
							font-size: 12px;
							color: #606266;
							margin-bottom: 8px;
						}

						/deep/ .el-upload--picture-card {
							width: 100px;
							height: 100px;
							line-height: 100px;
						}

						/deep/ .el-upload-list--picture-card .el-upload-list__item {
							width: 100px;
							height: 100px;
						}
					}
				}
			}
		}

		.dialog-footer {
			text-align: center;
			padding: 16px 20px;
			border-top: 1px solid #e4e7ed;

			.el-button {
				margin: 0 8px;
				min-width: 80px;
			}
		}
	}

	// 分页样式
	.pagination {

		/deep/ .el-pagination__total,
		/deep/ .el-pagination__jump {
			font-size: 12px;
		}

		/deep/ .el-pagination__sizes {
			margin: 0 16px 0 0;
		}

		/deep/ .btn-prev,
		/deep/ .btn-next,
		/deep/ .el-pager li,
		/deep/ .el-pagination__jump .el-input__inner {
			font-size: 12px;
			min-width: 28px;
			height: 28px;
			line-height: 28px;
		}
	}

	// 移动端适配
	@media (max-width: 768px) {
		.drug-management-container {
			flex-direction: column;

			.left-table-section {
				width: 100% !important;
				height: 50vh;

				&.collapsed {
					height: 50vh;
				}

				.category-tabs {
					overflow-x: auto;

					.lr {
						display: flex;

						.category-group {
							width: auto;
							white-space: nowrap;
						}
					}

				}
			}

			.right-table-section {
				width: 100% !important;
				height: 50vh;

				&.visible {
					width: 100%;
					height: 50vh;
				}
			}
		}

		.clinic-dialog {
			::v-deep .el-dialog {
				width: 90% !important;
			}

			.dialog-content {
				padding: 12px;

				.form-section {

					.clinic-form,
					.insurance-form {
						padding: 12px;
					}


					.file-upload-section {
						padding: 12px;

						.el-col {
							margin-bottom: 16px;
						}
					}
				}
			}
		}
	}

	// 超小屏幕适配
	@media (max-width: 480px) {
		.drug-management-container {

			.left-table-section,
			.right-table-section {
				padding: 12px;

				.search-filter-section .filter-group {
					flex-wrap: wrap;

					.el-input {
						margin: 8px 0 0 0 !important;
						width: 100% !important;
					}

					.el-button {
						margin: 8px 0 0 0 !important;
						width: 100%;
					}
				}
			}
		}
	}
</style>